import { Injectable } from '@angular/core';
import { GetResult, Preferences } from '@capacitor/preferences';
import { environment } from '@env/environment';

@Injectable()
export class StorageService
{
    readonly clearDatabaseKey = 'clear_database_key';
    readonly clearLocalStorageKey = 'clear_local_storage_key';

    async initialize(): Promise<void>
    {
        await Preferences.configure({ group: environment.databaseName, });

        const value = await this.get<string>(this.clearLocalStorageKey);

        if (value === null || value !== environment.clearLocalStorageKey)
        {
            await this.clear();
        }

        await this.set<string>(this.clearLocalStorageKey, environment.clearLocalStorageKey);
    }

    async get<T>(key: string): Promise<T | null>
    {
        try
        {
            const result: GetResult = await Preferences.get({ key, });

            if (!result || result.value === null)
            {
                return null;
            }

            return JSON.parse(result.value) as T;
        }
        catch (error: any)
        {
            console.error('storage.service get', error);

            return null;
        }
    }

    async set<T>(key: string, data: T): Promise<void>
    {
        try
        {
            const jsonData = JSON.stringify(data);

            await Preferences.set({ key, value: jsonData, });
        }
        catch (error: any)
        {
            console.error('storage.service set', error);
        }
    }

    async clear(): Promise<void>
    {
        try
        {
            await Preferences.clear();
        }
        catch (error: any)
        {
            console.error('storage.service clear', error);
        }
    }

    async remove(key: string): Promise<void>
    {
        try
        {
            await Preferences.remove({ key, });
        }
        catch (error: any)
        {
            console.error('storage.service remove', error);
        }
    }
}
